import { render, staticRenderFns } from "./VUserOrders.vue?vue&type=template&id=507e6d98&class=ui%20segment%20orders&"
import script from "./VUserOrders.vue?vue&type=script&lang=js&"
export * from "./VUserOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports